





















import Vue from 'vue';
import { DEFAULT_SEVERITIES } from './SeverityModel';
import SeverityInterface from './SeverityInterface';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class SeverityIcon extends Vue {
    // Severity is any of the severities in the severity model such as [success,alert,unknown,major,minor,info..]
    @Prop({ type: String, required: true })
    public severity!: '';
    // Pass in a color to set the color of the icon
    @Prop({ type: String, required: false, default: '' })
    public color!: '';
    @Prop({ type: Boolean, required: false, default: false })
    public getSeverityColor!: '';
    // Show text will show the severity word along with the icon
    @Prop({ type: Boolean, required: false, default: false })
    public showText!: '';
    // Pass in the tooltip toggle flag to enable togglig on icon
    @Prop({ type: Boolean, required: false, default: true })
    public showToolTips!: '';
    // Use standard vuetify icon sizes to change the icon size [x-small,small,medium,large,x-large]
    @Prop({ type: String, required: false })
    public size!: '';
    // Pass user custom severities list
    @Prop({ default: () => ([]), required: false })
    public severitiesList!: SeverityInterface;

    public severities!: SeverityInterface;

    public created() {
        this.severities = Object.keys(this.severitiesList).length ? this.severitiesList : DEFAULT_SEVERITIES;
    }

    public get severityIcon(): object {
        try {
            return this.severities[this.severity.toLowerCase().replace(/[^\w]/g,'')];
        } catch {
            return {icon:'mdi-record-circle'};
        }
    }
}
